
import { defineComponent, PropType } from 'vue';
import omegaup_OverlayPopup from '../OverlayPopup.vue';
import { AvailableViews } from './DemotionPopup.vue';
import T from '../../lang';

interface DifficultyLevel {
  id: number;
  description: string;
}

interface QualityLevel {
  id: number;
  description: string;
}

export default defineComponent({
  name: 'QualityPromotionPopup',
  components: {
    'omegaup-overlay-popup': omegaup_OverlayPopup,
  },
  props: {
    solved: {
      type: Boolean,
      default: false,
    },
    tried: {
      type: Boolean,
      default: false,
    },
    difficultyLevels: {
      type: Array as PropType<DifficultyLevel[]>,
      default: () => [
        { id: '0', description: T.qualityFormDifficultyVeryEasy },
        { id: '1', description: T.qualityFormDifficultyEasy },
        { id: '2', description: T.qualityFormDifficultyMedium },
        { id: '3', description: T.qualityFormDifficultyHard },
        { id: '4', description: T.qualityFormDifficultyVeryHard },
      ],
    },
    qualityLevels: {
      type: Array as PropType<QualityLevel[]>,
      default: () => [
        { id: '0', description: T.qualityFormQualityVeryBad },
        { id: '1', description: T.qualityFormQualityBad },
        { id: '2', description: T.qualityFormQualityFair },
        { id: '3', description: T.qualityFormQualityGood },
        { id: '4', description: T.qualityFormQualityVeryGood },
      ],
    },
  },
  emits: ['dismiss', 'submit'],
  data() {
    return {
      AvailableViews,
      T,
      currentView: AvailableViews.Content as AvailableViews,
      difficulty: '',
      quality: '',
    };
  },
  methods: {
    onCloseModal(currentView: AvailableViews): void {
      if (currentView !== AvailableViews.Thanks) {
        this.onDismiss();
        return;
      }
      this.onHide(false);
    },

    onHide(isDismissed: boolean): void {
      this.$emit('dismiss', this, isDismissed);
    },

    onDismiss(): void {
      this.$emit('dismiss', this, /*isDismissed=*/ true);
    },

    onSubmit(): void {
      this.$emit('submit', {
        solved: this.solved,
        tried: this.tried,
        difficulty: this.difficulty,
        quality: this.quality,
      });
      this.currentView = AvailableViews.Thanks;

      setTimeout(() => this.onHide(false), 2000);
    },
  },
});
